<form>
  <mat-card class="cur-card result-area" *ngIf="hasResult">
    <mat-card-header>
      <mat-card-title>検索結果</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div class="table-responsive">
        <table mat-table
          [dataSource]="dataSource">
          <ng-container matColumnDef="outputState">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>出力状態</th>
            <td mat-cell *matCellDef="let row">{{ row.outputState }}</td>
          </ng-container>
          <ng-container matColumnDef="reqretBankfcCode">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>依頼返却金融機関コード</th>
            <td mat-cell *matCellDef="let row">{{ row.reqretBankfcCode }}</td>
          </ng-container>
          <ng-container matColumnDef="kouzaFrikaeDate">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>口座振替日</th>
            <td mat-cell *matCellDef="let row">{{ row.kouzaFrikaeDate | date : 'YYYY/MM/dd' }}</td>
          </ng-container>
          <ng-container matColumnDef="reqReturnDeadline">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>依頼返却締切日</th>
            <td mat-cell *matCellDef="let row">{{ row.reqReturnDeadline | date : 'YYYY/MM/dd' }}</td>
          </ng-container>
          <ng-container matColumnDef="bankfcCode">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>金融機関コード</th>
            <td mat-cell *matCellDef="let row">{{ row.bankfcCode }}</td>
          </ng-container>
          <ng-container matColumnDef="bankfcMei">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>金融機関名</th>
            <td mat-cell *matCellDef="let row">{{ row.bankfcMei }}</td>
          </ng-container>
          <ng-container matColumnDef="branchCode">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>支店コード</th>
            <td mat-cell *matCellDef="let row">{{ row.branchCode }}</td>
          </ng-container>
          <ng-container matColumnDef="branchMei">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>支店名</th>
            <td mat-cell *matCellDef="let row">{{ row.branchMei }}</td>
          </ng-container>
          <ng-container matColumnDef="item">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>種目</th>
            <td mat-cell *matCellDef="let row">{{ row.item }}</td>
          </ng-container>
          <ng-container matColumnDef="accntn">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>口座番号</th>
            <td mat-cell *matCellDef="let row">{{ row.accntn }}</td>
          </ng-container>
          <ng-container matColumnDef="frikaeMny">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>振替金額[円]</th>
            <td mat-cell *matCellDef="let row" style="text-align: right;">{{ row.formatFrikaeMny }}</td>
          </ng-container>
          <ng-container matColumnDef="depositpersonMeigi">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>預金者名義</th>
            <td mat-cell *matCellDef="let row">{{ row.depositpersonMeigi }}</td>
          </ng-container>
          <ng-container matColumnDef="kokyakuNo">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>顧客番号</th>
            <td mat-cell *matCellDef="let row">{{ row.kokyakuNo }}</td>
          </ng-container>
          <ng-container matColumnDef="payCtrNo">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>支払契約番号</th>
            <td mat-cell *matCellDef="let row">{{ row.payCtrNo }}</td>
          </ng-container>
          <ng-container matColumnDef="aceptBaseCompany">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>受付拠点（会社）</th>
            <td mat-cell *matCellDef="let row">{{ row.aceptBaseCompany }}</td>
          </ng-container>
          <ng-container matColumnDef="aceptBaseSosiki">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>受付拠点（組織）</th>
            <td mat-cell *matCellDef="let row">{{ row.aceptBaseSosiki }}</td>
          </ng-container>
          <ng-container matColumnDef="aceptTntsh">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>受付担当者</th>
            <td mat-cell *matCellDef="let row">{{ row.aceptTntsh }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true" ></tr>
          <tr mat-row
            *matRowDef="let row; columns: displayedColumnsCol"
            class="clickable-mat-row"
            (click)="clickRow(row)"
          ></tr>
        </table>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="end center" width="30%">
        <mat-card-actions class="btn_area_right">
          <button type="button" mat-raised-button
            [disabled]="dataSource.data.length == 0 || !dispOutputButton"
            color="primary"
            class="btn btnPrint"
            (click)="onClickPrint()"
          >出力</button>
        </mat-card-actions>
      </div>
    </mat-card-content>
  </mat-card>
</form>
